export const newDataMenus = [
  {
    id: 1,
    name: 'CONTABILIDAD',
    route: '/dashboard',
    subMenus: [
      {
        id: 11,
        name: 'Parámetros',
        route: '/dashboard',
        categories: [
          {
            id: 111,
            name: 'TABLAS GENERALES',
            options: [
              {
                id: 1111,
                name: 'Parámetros generales',
                route: '/dashboard',
              },
              {
                id: 1112,
                name: 'Centro de costos',
                route: '/dashboard',
              },
              {
                id: 1113,
                name: 'Consecutivos',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 112,
            name: 'PLAN DE CUENTAS',
            options: [
              {
                id: 1121,
                name: 'Auxiliares contables',
                route: '/dashboard',
              },
              {
                id: 1122,
                name: 'Conceptos DIAN y medios magnéticos',
                route: '/dashboard',
              },
              {
                id: 1123,
                name: 'Formatos de la DIAN',
                route: '/dashboard',
              },
            ],
          },
        ],
      },
      {
        id: 12,
        name: 'Procesar',
        route: '/dashboard',
        categories: [
          {
            id: 121,
            name: 'MOVIMIENTOS',
            options: [
              {
                id: 1211,
                name: 'Documentos contables',
                route: '/dashboard',
              },
              {
                id: 1212,
                name: 'Cambios de Nits',
                route: '/dashboard',
              },
              {
                id: 1213,
                name: 'Cambios de Auxiliares',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 122,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
        ],
      },
      {
        id: 13,
        name: 'Informes',
        route: '/dashboard',
        categories: [
          {
            id: 131,
            name: 'MOVIMIENTOS',
            options: [
              {
                id: 1311,
                name: 'Documentos contables',
                route: '/dashboard',
              },
              {
                id: 1312,
                name: 'Cambios de Nits',
                route: '/dashboard',
              },
              {
                id: 1313,
                name: 'Cambios de Auxiliares',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 132,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 1321,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 1322,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 1323,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'TALENTO HUMANO',
    route: '/dashboard',
    subMenus: [
      {
        id: 21,
        name: 'Parámetros',
        route: '/dashboard',
        categories: [
          {
            id: 211,
            name: 'Tablas generales',
            options: [
              {
                id: 2111,
                name: 'Parámetros generales',
                route: '/dashboard',
              },
              {
                id: 2112,
                name: 'Centro de costos',
                route: '/dashboard',
              },
              {
                id: 2113,
                name: 'Consecutivos',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 212,
            name: 'Plan de cuentas',
            options: [
              {
                id: 2121,
                name: 'Auxiliares contables',
                route: '/dashboard',
              },
              {
                id: 2122,
                name: 'Conceptos DIAN y medios magnéticos',
                route: '/dashboard',
              },
              {
                id: 2123,
                name: 'Formatos de la DIAN',
                route: '/dashboard',
              },
            ],
          },
        ],
      },
      {
        id: 22,
        name: 'Procesar',
        route: '/dashboard',
        categories: [
          {
            id: 221,
            name: 'MOVIMIENTOS',
            options: [
              {
                id: 2211,
                name: 'Documentos contables',
                route: '/dashboard',
              },
              {
                id: 2212,
                name: 'Cambios de Nits',
                route: '/dashboard',
              },
              {
                id: 2213,
                name: 'Cambios de Auxiliares',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 222,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 2221,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 2222,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 2223,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
        ],
      },
      {
        id: 23,
        name: 'Informes',
        route: '/dashboard',
        categories: [
          {
            id: 231,
            name: 'MOVIMIENTOS',
            options: [
              {
                id: 2311,
                name: 'Documentos contables',
                route: '/dashboard',
              },
              {
                id: 2312,
                name: 'Cambios de Nits',
                route: '/dashboard',
              },
              {
                id: 2313,
                name: 'Cambios de Auxiliares',
                route: '/dashboard',
              },
            ],
          },
          {
            id: 232,
            name: 'PROCESOS AUTOMÁTICOS',
            options: [
              {
                id: 2321,
                name: 'Procesos automáticos 1',
                route: '/dashboard',
              },
              {
                id: 2322,
                name: 'Procesos automáticos 2',
                route: '/dashboard',
              },
              {
                id: 2323,
                name: 'Procesos automáticos 3',
                route: '/dashboard',
              },
            ],
          },
        ],
      },
    ],
  },
];
